import React from 'react'
import { StyledPowerByWsc } from './PowerByWsc.style'

const PowerByWsc = (): JSX.Element => {
  return <StyledPowerByWsc>Powered By WSC Sports</StyledPowerByWsc>
}

export default PowerByWsc
